import { SingleCustomerProduct } from 'utils/api/models/products/singleCustomerProduct';
import { chain } from 'lodash';

const CORP_FBB_COMMITMENT = 'CORP_FBB_COMMITMENT';

export const corpFbbCommitment = (products: SingleCustomerProduct[]) => {
	if (products) {
		return chain(products)
			.filter(({ group }) => group === CORP_FBB_COMMITMENT)
			.orderBy('startDate', 'desc')
			.head()
			.value();
	}
	return undefined;
};
